import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CostUnitService } from '../services/cost-unit.service';
import { UserService } from '../services/user.service';

@Component({
  selector: 'app-cost-unit-handler',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  template: '',
})
export class CostUnitHandlerComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private costUnitService = inject(CostUnitService);
  private userService = inject(UserService);
  private router = inject(Router);

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      const costUnit = params['kostenstelle'];

      if (costUnit) {
        const isLoggedIn = this.userService.isLoggedIn();
        void this.costUnitService.processCostUnit(costUnit).then(() => {
          const target = isLoggedIn ? 'registration' : '/auth/register';
          void this.router.navigateByUrl(target);
        });
      } else {
        // Ohne Kostenstelle gibt es nichts zu verarbeiten — sonst bliebe eine leere Seite stehen (#1222).
        void this.router.navigateByUrl('/', { replaceUrl: true });
      }
    });
  }
}
